//utils/analysis-sequencer.ts

import { supabase } from '../lib/supabase';

export async function triggerAnalysisSequence(
  transcript: string,
  meetingId: string,
  userId: string
) {
  try {
    console.log('Starting analysis sequence for meeting:', meetingId);
    
    // Call the serverless function for analysis
    const response = await fetch('/api/meeting-analysis/sequence', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ transcript, meetingId, userId }),
    });

    if (!response.ok) {
      throw new Error(`Analysis failed: ${response.statusText}`);
    }

    const result = await response.json();
    console.log('Analysis completed successfully:', result);

    return result;
  } catch (error) {
    console.error('Error in analysis sequence:', error);
    throw error;
  }
}